import { useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import CalendarNew from '../images/newDesign/Calendar.svg';
import Calendar from '../images/calendar.svg';
import styled from 'styled-components';
import "react-datepicker/dist/react-datepicker.css";
import he from 'date-fns/locale/he';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';


export const StyledDatepicker = styled.div`
  .react-datepicker__input-container {
    position: relative;
    width: auto;
    &::before {
      content: '';
      position: absolute;
      inset-inline-end: 14px;
      top: 13px;
      width: 25px;
      height: 25px;
      background-image: url(${Calendar});
      background-repeat: no-repeat;
      z-index: 9;
    }
    &::after {
      content: '';
      position: absolute;
      inset-inline-end: 0;
      top: 0;
      width: 52px;
      height: 52px;
      border-radius: 50%;
      border: 1px solid var(--bllink-blue);
    }
    & > input {
      padding-inline-end: 60px;
      min-width: 160px;
      width: 100%;
      font-weight: bold;
    }
  }
  .DayPickerInput-Overlay {
    z-index: 99;
  }

  &.one-line-design {
    .bllink-input-border {
      height: 30px;
      border: none;
      font-size: 14px;
      line-height: 22px;
      background-color: transparent;
      border-bottom: 1px solid rgba(110, 116, 255, 0.4);
      border-radius: 0;
      padding-inline-start: 2px;
      font-weight: 400 !important;
    } 

    .react-datepicker {
      border: none;

      .react-datepicker__triangle {
        display: none;
      }
    }

    .react-datepicker-popper {
      padding-top: 0;
    }

    .react-datepicker__input-container {
      position: relative;
      width: 100%;

      &::before {
        content: '';
        position: absolute;
        inset-inline-end: 14px;
        top: 0;
        width: 25px;
        height: 25px;
        background-image: url(${CalendarNew});
        background-repeat: no-repeat;
        z-index: 9;
      }

      &::after {
       display: none;
      }
      
      & > input {
        padding-inline-end: 60px;
        min-width: 160px;
        font-weight: bold;
      }
    }

    .react-datepicker__header {
      background-color: transparent;
      padding-top: 30px;
      border: none;

      .react-datepicker__day-names {
        font-family: var(--bllink-font-primary);
        margin-top: 15px;

        .react-datepicker__day-name {
          color: rgba(55, 54, 71, 0.7);
          font-size: 12px;
        }
      }

      .react-datepicker__current-month {
        font-weight: 700;
        font-size: 14px;
        color: rgba(55, 54, 71, 0.7);
        font-family: var(--bllink-font-primary);
      }
    }

    .react-datepicker__header.react-datepicker-year-header {
      font-weight: 700;
      font-size: 14px;
      color: rgba(55, 54, 71, 0.7);
      font-family: var(--bllink-font-primary);
    }

    .react-datepicker__day, .react-datepicker__month-text {
      background-color: #F9F9FF;
      border-radius: 3px;
      font-weight: 700;
      color: rgba(55, 54, 71, 0.7);
      font-size: 12px;
      font-family: var(--bllink-font-primary);

      :hover {
        color: #6E74FF;
      }
    }

    .react-datepicker__day--today, .react-datepicker__month-text--today {
      color: #6E74FF;
    }

    .react-datepicker__day--outside-month, .react-datepicker__month--disabled {
      color: rgba(55, 54, 71, 0.4);
      background-color: transparent;
      font-weight: 400;
    }

    .react-datepicker__day--selected, .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected {
      border: 1px solid #6E74FF;
      color: #6E74FF;
      font-weight: 700;
    }

    .react-datepicker__navigation {
      background: #E9E9FD;
      border-radius: 50px;
      height: 22px;
      width: 22px;
      box-shadow: 2px 2px 8px 0px rgba(34, 60, 80, 0.2);
      top: 30px;
    }

    .react-datepicker__navigation-icon--previous, .react-datepicker__navigation-icon--next {
      ::before {
        border-color: #373647;
        top: 11px;
        width: 8px;
        height: 8px;
        border-width: 2px 2px 0 0;
      }
    }

    .react-datepicker__navigation--next {
      right: 10px;
    }

    .react-datepicker__navigation--previous {
      left: 10px;
    }

    .react-datepicker__navigation-icon--previous {
      ::before {
        right: -3px;
      }
    }

    .react-datepicker__navigation-icon--next {
      ::before {
        left: -3px;
      }
    }  
  }

  &.month-year-calendar {
    .bllink-input-border {
      height: 40px;
      padding-inline-start: 15px;
      padding-inline-end: 40px;
      border: 0;
      font-size: 14px;
      line-height: 22px;
      box-shadow: 0 3px 10px rgba(89, 102, 137, 0.12);
      border-radius: 25px;
    }

    .react-datepicker-popper {
      margin-top: 1px;
    }

    .react-datepicker__input-container {
      position: relative;
      width: auto;
      &::before {
        inset-inline-end: 14px;
        top: 5px;
        width: 26px;
        height: 26px;
        background-image: url(${CalendarNew});
      }
      &::after {
        display: none;
      }
      & > input {
        padding-inline-end: 60px;
        min-width: 160px;
        width: 100%;
        font-weight: bold;
      }
    }
  }

  &.payment-flow {
    .react-datepicker-wrapper {
      position: relative;
      z-index: 9999;

      .bllink-input-border {
        padding-inline-start: 15px;
        padding-inline-end: 40px;
        background: rgb(243, 241, 255);
        border-radius: 10px;
        border: none;
        font-size: 18px;
        font-weight: 700;
        color: rgb(55, 54, 71);
      }
    }
    
    .react-datepicker-popper {
      margin-top: 0;
      padding-top: 0;
      
      .react-datepicker {
        border: none;
        top: -10px;
  
        .react-datepicker__triangle {
          display: none;
        }
      }
      
      .react-datepicker__month-container {
        background-color: #E6E3FC;
        width: 310px;
        border-radius: 10px;

        .react-datepicker__header {
          background-color: #E6E3FC;
          border: none;
          padding-top: 36px;

          .react-datepicker__current-month {
            padding-bottom: 21px;
            font-family: var(--bllink-font-primary);
          }

          .react-datepicker__day-names {
            font-size: 12px;
            font-family: var(--bllink-font-primary);
            font-weight: 700;

            .react-datepicker__day-name {
              color: rgba(55, 54, 71, 0.7);
              width: 30px;
              height: 30px;
            }
          }
        }

        .react-datepicker__month {
          .react-datepicker__day {
            background: #F3F1FF;
            border-radius: 3px;
            color: rgba(55, 54, 71, 0.7);
            font-weight: 700;
            font-family: var(--bllink-font-primary);
            margin: 3px;
            font-size: 12px;
            width: 30px;
            height: 30px;
          }

          .react-datepicker__day--today {
            background: #9e9e9e;
          }

          .react-datepicker__day--selected {
            background: #6E74FF;
            color: #FFFFFF;
          }

          .react-datepicker__day--outside-month {
            background: transparent;
          }

          .react-datepicker__day--disabled {
            background: transparent;
            color: rgba(55, 54, 71, 0.4);
          }
        }
      }

      .react-datepicker__navigation {
        width: 30px;
        height: 30px;
        background: #DBD6FB;
        border-radius: 50%;
        margin: 30px;

        .react-datepicker__navigation-icon {
          font-size: 15px;
          top: 0;
          left: 0;
          right: 0;
        }

        .react-datepicker__navigation-icon--next::before, .react-datepicker__navigation-icon--previous::before {
          border-width: 2px 2px 0 0;
          border-color: #373647;
        }
      }
    }

    .react-datepicker__input-container {
      width: 100%;

      &::before {
        inset-inline-end: 14px;
        top: 10px;
        background-image: url(${CalendarNew});
      }
      &::after {
        display: none;
      }
    }
  }

  &.classic-bllink {
    .react-datepicker-wrapper {
      position: relative;
      z-index: 9999;

      .bllink-input-border {
        padding-inline-start: 15px;
        padding-inline-end: 40px;
        background: #FFFFFF;
        border-radius: 100px;
        border: 1px solid rgba(110, 116, 255, 0.4);
        font-family: var(--bllink-font-primary);
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: rgb(55, 54, 71);
        width: 210px;
        height: 37px;
      }
    }

    .react-datepicker {
      width: 250px;

      .react-datepicker__month-container {
        float: none;
      }

    }
    .react-datepicker__input-container {
      position: relative;
      width: 100%;

      &::before {
        content: '';
        position: absolute;
        inset-inline-end: 14px;
        top: 8px;
        left: ${({ ltr }) => ltr ? '' : '12px'};
        right: ${({ ltr }) => ltr ? '12px' : ''};
        background-image: url(${CalendarNew});
        background-repeat: no-repeat;
        background-size: 22px;
        z-index: 9;
      }
`;

const Container = ({ className, children }) => {
  return (
    <div style={{ background: '#FFFFFF', width: '580px', display: 'flex', justifyContent: 'center', borderRadius: '11px', paddingBottom: '20px' }}>
      <div className={className}>
        <div style={{ position: "relative" }}>{children}</div>
      </div>
    </div>
  );
};

const DatepickerPortal = ({ date, onChange, ltr, language, minDate, maxDate, id, placeholder, name, onClickOutside, withPortal=true, className, showArrow=true, container, showMonthYear }) => {
    let locale;
    if (language && typeof language === 'string') {
        const lng = language.toLowerCase();
        if (lng === 'es') {
            locale = es;
        } else if (lng === 'en') {
            locale = en;
        } else if (lng === 'he') {
            locale = he;
        }
    } else {
        locale = ltr ? en : he;
    }

    // avoid opening keyboard when opening dropdown
    const pickerRef = useRef(null);

    useEffect(() => {
      if (pickerRef.current !== null) pickerRef.current.input.readOnly = true;
  }, [pickerRef]);

    return (
      <StyledDatepicker ltr={ltr} className={className}>
        <DatePicker
            selected={date}
            onChange={onChange}
            dateFormat={showMonthYear ? "MMMM yyyy" : "dd/MM/yyyy"}
            locale={locale}
            className='bllink-input-border'
            minDate={minDate}
            maxDate={maxDate}
            id={id}
            name={name}
            placeholderText={placeholder}
            withPortal={withPortal}
            onClickOutside={onClickOutside}
            showPopperArrow={showArrow}
            calendarContainer={container && Container}
            showMonthYearPicker={showMonthYear}
            disabledKeyboardNavigation
            ref={pickerRef}
        />
      </StyledDatepicker>
    );
};

export default DatepickerPortal;
